import { Helpers } from '../../helpers';
import { IWell } from '../../interfaces/iwell';
import { Area } from '../area';
import { AreaTeam } from '../area-team';
import { Asset } from '../asset';
import { BusinessAssociate } from '../business-associate';
import { ChangeRequestWell } from '../change-request-well';
import { CompletionDesign } from '../completion-design';
import { CompletionsAreaTeam } from '../completions-area-team';
import { County } from '../county';
import { DrillDesign } from '../drill-design';
import { DrillGroupWell } from '../drill-group-well';
import { DrillingAreaTeam } from '../drilling-area-team';
import { EconomicsCalculationsAnnualValue } from '../economics-calculations-annual-value';
import { EconomicsCalculationsDailyValue } from '../economics-calculations-daily-value';
import { FieldDevelopmentTeam } from '../field-development-team';
import { ForecastHorizontalDetail } from '../forecast-horizontal-detail';
import { ForecastParameter } from '../forecast-parameter';
import { FracGroupWell } from '../frac-group-well';
import { Pad } from '../pad';
import { PermitType } from '../permit-type';
import { PriorityRankingCategory } from '../priority-ranking-category';
import { ProductionGroupWell } from '../production-group-well';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { RegulatoryWellType } from '../regulatory-well-type';
import { RigRampStatus } from '../rig-ramp-status';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { ScenarioWell } from '../scenario-well';
import { ScheduleActivity } from '../schedule-activity';
import { StackingStrategy } from '../stacking-strategy';
import { State } from '../state';
import { TankBattery } from '../tank-battery';
import { TargetFormation } from '../target-formation';
import { TesterType } from '../tester-type';
import { Township } from '../township';
import { TypeCurve } from '../type-curve';
import { UserRankingCategory } from '../user-ranking-category';
import { WellDesign } from '../well-design';
import { WellProfile } from '../well-profile';
import { WellStatus } from '../well-status';
import { WellType } from '../well-type';

export class WellBase {
  WellId: number;
  Ssn: string;
  Name: string | null;
  PadId: number | null;
  StateId: string | null;
  SurfaceBlock: string | null;
  SurfaceSection: string | null;
  BottomholeBlock: string | null;
  BottomholeSection: string | null;
  TargetFormationId: number | null;
  LateralLength: number | null;
  AreaTeamId: number | null;
  FieldDevelopmentTeamId: number | null;
  SaltWaterDisposalFacilityId: number | null;
  TypeCurveId: number | null;
  WellStatusId: number | null;
  DrillDesignId: number | null;
  StandardDrillDesignId: number | null;
  CompletionDesignId: number | null;
  StandardCompletionDesignId: number | null;
  StackingStrategyId: number | null;
  CurrentSpacing: number | null;
  WellSpacing: number | null;
  InitialTechnicalReviewSpacing: number | null;
  InitialTechnicalReviewApprovalDate: Date | null;
  HasSpacingLock: boolean | null;
  IsGeoHazard: boolean;
  ChildOffset: number | null;
  IsJointVenture: boolean;
  IsAppraisal: boolean;
  IsAllocated: boolean;
  ApproximateFlowLineLength: number | null;
  MustSpudByObligation: Date | null;
  CriticalDate: Date | null;
  MeterSep: string | null;
  ContinuousDrillingObligation: number | null;
  LandEstimate: number | null;
  LandNotes: string | null;
  ChokeStatus: boolean | null;
  ChokePercent: number | null;
  ChokeAllowableDays: number | null;
  PermitTypeId: number | null;
  WellTypeId: number | null;
  RegulatoryExceptions: string | null;
  RegulatoryEstimate: number | null;
  RegulatoryNotes: string | null;
  DrillCompCost: number | null;
  DirectReturnOnInvestmentAmount: number | null;
  PriceDeck: string | null;
  FirstAvailableDate: Date | null;
  LeaseObligationsSatisfyingDate: Date | null;
  ProvenUndrilledSatisfyingDate: Date | null;
  IsScheduleLive: boolean;
  PriorityRanking: number | null;
  PriorityRankingCategoryId: number | null;
  RigRampStatusId: number | null;
  WellDesignId: number | null;
  TankBatteryId: number | null;
  PGauge: boolean | null;
  BullpenStatusId: number | null;
  LeaseAreaId: number | null;
  GeoCenter: object | null;
  Shape: object | null;
  SysStartTime: Date;
  SysEndTime: Date;
  UserRankingCategoryId: number | null;
  UserRankingValue: number | null;
  FracStart: Date | null;
  FracEnd: Date | null;
  FracOrder: number;
  SpudDate: Date | null;
  RigReleaseDate: Date | null;
  PadRigReleaseDate: Date | null;
  PutOnProductionDate: Date | null;
  TurnedOvertoProductionDate: Date | null;
  _TankBatteryName: string | null;
  FracPadOrder: number | null;
  DrillCurrentOrder: number | null;
  DrillOrder: number | null;
  DrillPadOrder: number | null;
  _DrillingRig: string | null;
  DrillingRigId: number | null;
  PadSequence: string | null;
  _TypeCurve: string | null;
  CreatedByUID: string | null;
  CreatedDate: string | null;
  _FracFleet: string | null;
  FracFleetId: number | null;
  _AssetTeamCode: string | null;
  AssetTeamId: number | null;
  OWID: number | null;
  WellNumber: string | null;
  OperatingBusinessSegment: string | null;
  NetWorkingInterest: number | null;
  GrossWorkingInterest: number | null;
  DivisionOrdersPayoutStatusCode: string | null;
  DivisionOrdersMajorProductCode: string | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  ActualWorkingInterest: number | null;
  ForecastedWorkingInterest: number | null;
  ForecastedNetRevenueInterest: number | null;
  SurfaceHoleLocationPointOfPenetrationCoordinate: object | null;
  FirstTakePointCoordinate: object | null;
  BottomHoleLocationCoordinate: object | null;
  BusinessAssociateId: number | null;
  AriesPropertyNumber: string | null;
  API: string | null;
  API2: string | null;
  TotalAcresInLease: number | null;
  GroundElevation: number | null;
  KBElevation: number | null;
  WaterBoardDepth: number | null;
  PermitLicenseNumber: string | null;
  RegulatoryAgency: string | null;
  RegulatoryDistrict: string | null;
  SurfaceHoleLocationPointOfPenetrationXCoordinate: number | null;
  SurfaceHoleLocationPointOfPenetrationYCoordinate: number | null;
  SurfaceNSDistance: number | null;
  SurfaceEWDistance: number | null;
  SurfaceNSReference: string | null;
  SurfaceEWReference: string | null;
  LatLongDatum: string | null;
  RegulatoryStatus: string | null;
  BottomHoleLocationYCoordinate: number | null;
  BottomHoleLocationXCoordinate: number | null;
  BottomHoleNSDistance: number | null;
  BottomHoleEWDistance: number | null;
  BottomHoleNSReference: string | null;
  BottomHoleEWReference: string | null;
  WellProfileId: number | null;
  Note: string | null;
  BottomHoleTownship: string | null;
  BottomHoleSurvey: string | null;
  WellviewWellType: string | null;
  SysActionUID: string | null;
  AssetId: number | null;
  FirstTakePointXCoordinate: number | null;
  FirstTakePointYCoordinate: number | null;
  IsOffLeasePointOfPenetration: boolean | null;
  LeftSpacing: number | null;
  RightSpacing: number | null;
  ParentSpacing: number | null;
  CompletionsAreaTeamId: number | null;
  DrillingAreaTeamId: number | null;
  TownshipId: number | null;
  CountyId: number | null;
  SurfaceSurvey: string | null;
  WellSerialNumber: number | null;
  TurnedOvertoCompletionsDate: Date | null;
  CurrentDepth: number | null;
  StartDepthPlan: number | null;
  EndDepthPlan: number | null;
  ActualFracStagesCompleted: number | null;
  PlannedFracStages: number | null;
  NumberOfPlugsDrilled: number | null;
  PercentOfPlugsDrilled: number | null;
  CompletedLateralLength: number | null;
  FracPlugNumber: string | null;
  ActualStartDate: Date | null;
  ActualFinishDate: Date | null;
  ReserveStatus: string | null;
  ReserveCat: string | null;
  Comments: string | null;
  TesterTypeId: number | null;
  RegulatoryWellTypeId: number | null;
  PreliminaryNetWorkingInterest: number | null;
  PreliminaryNetRevenueInterest: number | null;
  EstimatedNetWorkingInterest: number | null;
  EstimatedNetRevenueInterest: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ChangeRequestWells_Well?: Array<ChangeRequestWell> | null;
  DrillGroupWells_Well?: Array<DrillGroupWell> | null;
  EconomicsCalculationsAnnualValues_Well?: Array<EconomicsCalculationsAnnualValue> | null;
  EconomicsCalculationsDailyValues_Well?: Array<EconomicsCalculationsDailyValue> | null;
  ForecastHorizontalDetails_Well?: Array<ForecastHorizontalDetail> | null;
  ForecastParameter_Well?: Array<ForecastParameter> | null;
  FracGroupWells_Well?: Array<FracGroupWell> | null;
  ProductionGroupWells_Well?: Array<ProductionGroupWell> | null;
  ProjectCompletionsParameters_Well?: Array<ProjectCompletionsParameter> | null;
  ProjectDrillingParameters_Well?: Array<ProjectDrillingParameter> | null;
  ScenarioWells_Well?: Array<ScenarioWell> | null;
  ScheduleActivities_Well?: Array<ScheduleActivity> | null;
  AreaTeam?: AreaTeam;
  Asset?: Asset;
  BusinessAssociate?: BusinessAssociate;
  CompletionDesign?: CompletionDesign;
  CompletionsAreaTeam?: CompletionsAreaTeam;
  County?: County;
  DrillDesign?: DrillDesign;
  DrillingAreaTeam?: DrillingAreaTeam;
  FieldDevelopmentTeam?: FieldDevelopmentTeam;
  Pad?: Pad;
  PermitType?: PermitType;
  PriorityRankingCategory?: PriorityRankingCategory;
  RegulatoryWellType?: RegulatoryWellType;
  RigRampStatus?: RigRampStatus;
  SaltWaterDisposalFacility?: SaltWaterDisposalFacility;
  StackingStrategy?: StackingStrategy;
  State?: State;
  TankBattery?: TankBattery;
  TargetFormation?: TargetFormation;
  TesterType?: TesterType;
  Township?: Township;
  TypeCurve?: TypeCurve;
  UserRankingCategory?: UserRankingCategory;
  WellDesign?: WellDesign;
  WellProfile?: WellProfile;
  WellStatus?: WellStatus;
  WellType?: WellType;
  LeaseArea?: Area;
  StandardCompletionDesign?: CompletionDesign;
  StandardDrillDesign?: DrillDesign;

  constructor(item?: IWell) {
    if (item) {

      this.WellId = item.WellId;
      this.Ssn = item.Ssn;
      this.Name = item.Name;
      this.PadId = item.PadId;
      this.StateId = item.StateId;
      this.SurfaceBlock = item.SurfaceBlock;
      this.SurfaceSection = item.SurfaceSection;
      this.BottomholeBlock = item.BottomholeBlock;
      this.BottomholeSection = item.BottomholeSection;
      this.TargetFormationId = item.TargetFormationId;
      this.LateralLength = item.LateralLength;
      this.AreaTeamId = item.AreaTeamId;
      this.FieldDevelopmentTeamId = item.FieldDevelopmentTeamId;
      this.SaltWaterDisposalFacilityId = item.SaltWaterDisposalFacilityId;
      this.TypeCurveId = item.TypeCurveId;
      this.WellStatusId = item.WellStatusId;
      this.DrillDesignId = item.DrillDesignId;
      this.StandardDrillDesignId = item.StandardDrillDesignId;
      this.CompletionDesignId = item.CompletionDesignId;
      this.StandardCompletionDesignId = item.StandardCompletionDesignId;
      this.StackingStrategyId = item.StackingStrategyId;
      this.CurrentSpacing = item.CurrentSpacing;
      this.WellSpacing = item.WellSpacing;
      this.InitialTechnicalReviewSpacing = item.InitialTechnicalReviewSpacing;
      this.InitialTechnicalReviewApprovalDate = item.InitialTechnicalReviewApprovalDate ? new Date(item.InitialTechnicalReviewApprovalDate) : null;
      this.HasSpacingLock = item.HasSpacingLock;
      this.IsGeoHazard = item.IsGeoHazard;
      this.ChildOffset = item.ChildOffset;
      this.IsJointVenture = item.IsJointVenture;
      this.IsAppraisal = item.IsAppraisal;
      this.IsAllocated = item.IsAllocated;
      this.ApproximateFlowLineLength = item.ApproximateFlowLineLength;
      this.MustSpudByObligation = item.MustSpudByObligation ? new Date(item.MustSpudByObligation) : null;
      this.CriticalDate = item.CriticalDate ? new Date(item.CriticalDate) : null;
      this.MeterSep = item.MeterSep;
      this.ContinuousDrillingObligation = item.ContinuousDrillingObligation;
      this.LandEstimate = item.LandEstimate;
      this.LandNotes = item.LandNotes;
      this.ChokeStatus = item.ChokeStatus;
      this.ChokePercent = item.ChokePercent;
      this.ChokeAllowableDays = item.ChokeAllowableDays;
      this.PermitTypeId = item.PermitTypeId;
      this.WellTypeId = item.WellTypeId;
      this.RegulatoryExceptions = item.RegulatoryExceptions;
      this.RegulatoryEstimate = item.RegulatoryEstimate;
      this.RegulatoryNotes = item.RegulatoryNotes;
      this.DrillCompCost = item.DrillCompCost;
      this.DirectReturnOnInvestmentAmount = item.DirectReturnOnInvestmentAmount;
      this.PriceDeck = item.PriceDeck;
      this.FirstAvailableDate = item.FirstAvailableDate ? new Date(item.FirstAvailableDate) : null;
      this.LeaseObligationsSatisfyingDate = item.LeaseObligationsSatisfyingDate ? new Date(item.LeaseObligationsSatisfyingDate) : null;
      this.ProvenUndrilledSatisfyingDate = item.ProvenUndrilledSatisfyingDate ? new Date(item.ProvenUndrilledSatisfyingDate) : null;
      this.IsScheduleLive = item.IsScheduleLive;
      this.PriorityRanking = item.PriorityRanking;
      this.PriorityRankingCategoryId = item.PriorityRankingCategoryId;
      this.RigRampStatusId = item.RigRampStatusId;
      this.WellDesignId = item.WellDesignId;
      this.TankBatteryId = item.TankBatteryId;
      this.PGauge = item.PGauge;
      this.BullpenStatusId = item.BullpenStatusId;
      this.LeaseAreaId = item.LeaseAreaId;
      this.GeoCenter = item.GeoCenter;
      this.Shape = item.Shape;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.UserRankingCategoryId = item.UserRankingCategoryId;
      this.UserRankingValue = item.UserRankingValue;
      this.FracStart = item.FracStart ? new Date(item.FracStart) : null;
      this.FracEnd = item.FracEnd ? new Date(item.FracEnd) : null;
      this.FracOrder = item.FracOrder;
      this.SpudDate = item.SpudDate ? new Date(item.SpudDate) : null;
      this.RigReleaseDate = item.RigReleaseDate ? new Date(item.RigReleaseDate) : null;
      this.PadRigReleaseDate = item.PadRigReleaseDate ? new Date(item.PadRigReleaseDate) : null;
      this.PutOnProductionDate = item.PutOnProductionDate ? new Date(item.PutOnProductionDate) : null;
      this.TurnedOvertoProductionDate = item.TurnedOvertoProductionDate ? new Date(item.TurnedOvertoProductionDate) : null;
      this._TankBatteryName = item._TankBatteryName;
      this.FracPadOrder = item.FracPadOrder;
      this.DrillCurrentOrder = item.DrillCurrentOrder;
      this.DrillOrder = item.DrillOrder;
      this.DrillPadOrder = item.DrillPadOrder;
      this._DrillingRig = item._DrillingRig;
      this.DrillingRigId = item.DrillingRigId;
      this.PadSequence = item.PadSequence;
      this.CreatedByUID = item.CreatedByUID;
      this.CreatedDate = item.CreatedDate;
      this.FracFleetId = item.FracFleetId;
      this._AssetTeamCode = item._AssetTeamCode;
      this.AssetTeamId = item.AssetTeamId;
      this.OWID = item.OWID;
      this.WellNumber = item.WellNumber;
      this.OperatingBusinessSegment = item.OperatingBusinessSegment;
      this.NetWorkingInterest = item.NetWorkingInterest;
      this.GrossWorkingInterest = item.GrossWorkingInterest;
      this.DivisionOrdersPayoutStatusCode = item.DivisionOrdersPayoutStatusCode;
      this.DivisionOrdersMajorProductCode = item.DivisionOrdersMajorProductCode;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.ActualWorkingInterest = item.ActualWorkingInterest;
      this.ForecastedWorkingInterest = item.ForecastedWorkingInterest;
      this.ForecastedNetRevenueInterest = item.ForecastedNetRevenueInterest;
      this.SurfaceHoleLocationPointOfPenetrationCoordinate = item.SurfaceHoleLocationPointOfPenetrationCoordinate;
      this.FirstTakePointCoordinate = item.FirstTakePointCoordinate;
      this.BottomHoleLocationCoordinate = item.BottomHoleLocationCoordinate;
      this.BusinessAssociateId = item.BusinessAssociateId;
      this.AriesPropertyNumber = item.AriesPropertyNumber;
      this.API = item.API;
      this.API2 = item.API2;
      this.TotalAcresInLease = item.TotalAcresInLease;
      this.GroundElevation = item.GroundElevation;
      this.KBElevation = item.KBElevation;
      this.WaterBoardDepth = item.WaterBoardDepth;
      this.PermitLicenseNumber = item.PermitLicenseNumber;
      this.RegulatoryAgency = item.RegulatoryAgency;
      this.RegulatoryDistrict = item.RegulatoryDistrict;
      this.SurfaceHoleLocationPointOfPenetrationXCoordinate = item.SurfaceHoleLocationPointOfPenetrationXCoordinate;
      this.SurfaceHoleLocationPointOfPenetrationYCoordinate = item.SurfaceHoleLocationPointOfPenetrationYCoordinate;
      this.SurfaceNSDistance = item.SurfaceNSDistance;
      this.SurfaceEWDistance = item.SurfaceEWDistance;
      this.SurfaceNSReference = item.SurfaceNSReference;
      this.SurfaceEWReference = item.SurfaceEWReference;
      this.LatLongDatum = item.LatLongDatum;
      this.RegulatoryStatus = item.RegulatoryStatus;
      this.BottomHoleLocationYCoordinate = item.BottomHoleLocationYCoordinate;
      this.BottomHoleLocationXCoordinate = item.BottomHoleLocationXCoordinate;
      this.BottomHoleNSDistance = item.BottomHoleNSDistance;
      this.BottomHoleEWDistance = item.BottomHoleEWDistance;
      this.BottomHoleNSReference = item.BottomHoleNSReference;
      this.BottomHoleEWReference = item.BottomHoleEWReference;
      this.WellProfileId = item.WellProfileId;
      this.Note = item.Note;
      this.BottomHoleTownship = item.BottomHoleTownship;
      this.BottomHoleSurvey = item.BottomHoleSurvey;
      this.WellviewWellType = item.WellviewWellType;
      this.SysActionUID = item.SysActionUID;
      this.AssetId = item.AssetId;
      this.FirstTakePointXCoordinate = item.FirstTakePointXCoordinate;
      this.FirstTakePointYCoordinate = item.FirstTakePointYCoordinate;
      this.IsOffLeasePointOfPenetration = item.IsOffLeasePointOfPenetration;
      this.LeftSpacing = item.LeftSpacing;
      this.RightSpacing = item.RightSpacing;
      this.ParentSpacing = item.ParentSpacing;
      this.CompletionsAreaTeamId = item.CompletionsAreaTeamId;
      this.DrillingAreaTeamId = item.DrillingAreaTeamId;
      this.TownshipId = item.TownshipId;
      this.CountyId = item.CountyId;
      this.SurfaceSurvey = item.SurfaceSurvey;
      this.WellSerialNumber = item.WellSerialNumber;
      this.TurnedOvertoCompletionsDate = item.TurnedOvertoCompletionsDate ? new Date(item.TurnedOvertoCompletionsDate) : null;
      this.CurrentDepth = item.CurrentDepth;
      this.StartDepthPlan = item.StartDepthPlan;
      this.EndDepthPlan = item.EndDepthPlan;
      this.ActualFracStagesCompleted = item.ActualFracStagesCompleted;
      this.PlannedFracStages = item.PlannedFracStages;
      this.NumberOfPlugsDrilled = item.NumberOfPlugsDrilled;
      this.PercentOfPlugsDrilled = item.PercentOfPlugsDrilled;
      this.CompletedLateralLength = item.CompletedLateralLength;
      this.FracPlugNumber = item.FracPlugNumber;
      this.ActualStartDate = item.ActualStartDate ? new Date(item.ActualStartDate) : null;
      this.ActualFinishDate = item.ActualFinishDate ? new Date(item.ActualFinishDate) : null;
      this.ReserveStatus = item.ReserveStatus;
      this.ReserveCat = item.ReserveCat;
      this.Comments = item.Comments;
      this.TesterTypeId = item.TesterTypeId;
      this.RegulatoryWellTypeId = item.RegulatoryWellTypeId;
      this.PreliminaryNetWorkingInterest = item.PreliminaryNetWorkingInterest;
      this.PreliminaryNetRevenueInterest = item.PreliminaryNetRevenueInterest;
      this.EstimatedNetWorkingInterest = item.EstimatedNetWorkingInterest;
      this.EstimatedNetRevenueInterest = item.EstimatedNetRevenueInterest;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ChangeRequestWells_Well = Helpers.createClassArray(ChangeRequestWell, item.ChangeRequestWells_Well);
      this.DrillGroupWells_Well = Helpers.createClassArray(DrillGroupWell, item.DrillGroupWells_Well);
      this.EconomicsCalculationsAnnualValues_Well = Helpers.createClassArray(EconomicsCalculationsAnnualValue, item.EconomicsCalculationsAnnualValues_Well);
      this.EconomicsCalculationsDailyValues_Well = Helpers.createClassArray(EconomicsCalculationsDailyValue, item.EconomicsCalculationsDailyValues_Well);
      this.ForecastHorizontalDetails_Well = Helpers.createClassArray(ForecastHorizontalDetail, item.ForecastHorizontalDetails_Well);
      this.ForecastParameter_Well = Helpers.createClassArray(ForecastParameter, item.ForecastParameter_Well);
      this.FracGroupWells_Well = Helpers.createClassArray(FracGroupWell, item.FracGroupWells_Well);
      this.ProductionGroupWells_Well = Helpers.createClassArray(ProductionGroupWell, item.ProductionGroupWells_Well);
      this.ProjectCompletionsParameters_Well = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_Well);
      this.ProjectDrillingParameters_Well = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_Well);
      this.ScenarioWells_Well = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_Well);
      this.ScheduleActivities_Well = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_Well);
      this.AreaTeam = new AreaTeam(item.AreaTeam);
      this.Asset = new Asset(item.Asset);
      this.BusinessAssociate = new BusinessAssociate(item.BusinessAssociate);
      this.CompletionDesign = new CompletionDesign(item.CompletionDesign);
      this.CompletionsAreaTeam = new CompletionsAreaTeam(item.CompletionsAreaTeam);
      this.County = new County(item.County);
      this.DrillDesign = new DrillDesign(item.DrillDesign);
      this.DrillingAreaTeam = new DrillingAreaTeam(item.DrillingAreaTeam);
      this.FieldDevelopmentTeam = new FieldDevelopmentTeam(item.FieldDevelopmentTeam);
      this.Pad = new Pad(item.Pad);
      this.PermitType = new PermitType(item.PermitType);
      this.PriorityRankingCategory = new PriorityRankingCategory(item.PriorityRankingCategory);
      this.RegulatoryWellType = new RegulatoryWellType(item.RegulatoryWellType);
      this.RigRampStatus = new RigRampStatus(item.RigRampStatus);
      this.SaltWaterDisposalFacility = new SaltWaterDisposalFacility(item.SaltWaterDisposalFacility);
      this.StackingStrategy = new StackingStrategy(item.StackingStrategy);
      this.State = new State(item.State);
      this.TankBattery = new TankBattery(item.TankBattery);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
      this.TesterType = new TesterType(item.TesterType);
      this.Township = new Township(item.Township);
      this.TypeCurve = new TypeCurve(item.TypeCurve);
      this.UserRankingCategory = new UserRankingCategory(item.UserRankingCategory);
      this.WellDesign = new WellDesign(item.WellDesign);
      this.WellProfile = new WellProfile(item.WellProfile);
      this.WellStatus = new WellStatus(item.WellStatus);
      this.WellType = new WellType(item.WellType);
      this.LeaseArea = new Area(item.LeaseArea);
      this.StandardCompletionDesign = new CompletionDesign(item.StandardCompletionDesign);
      this.StandardDrillDesign = new DrillDesign(item.StandardDrillDesign);
    }
  }
}